import { useState, useEffect, useContext, useRef } from 'react'
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import Countdown, { zeroPad } from "react-countdown";

import { FaArrowRight } from "react-icons/fa";
import { MdOutlineLocalPrintshop, MdOutlineFactCheck, MdOutlineSend, MdOutlineTextIncrease, MdOutlineTextDecrease, MdOutlineFileDownload, MdCheckBoxOutlineBlank } from "react-icons/md";
import { IoMegaphoneOutline } from "react-icons/io5";
import { AiOutlineAppstoreAdd } from "react-icons/ai";

import logo from '../../assets/logo.png';
import './css/task.css'

import { AppContext } from "../../Context";
import Paging from './components/paging'
import Question from './components/question'
import Fetch, { Loader, GET } from "../../inc/Fetch"; 
import { UserLoginSection } from "../../components/Elements";
import Header from "./Header";
import Ready, { TimeEnded, ScoreView } from "./components/Ready";
import Permission from "../Permission";

export default function Start({action}) {

    
    const { t } = useTranslation();
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    const refC = useRef(false);

    var style = window.getComputedStyle(document.body);
    
    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;

    const [show, setshow] = useState(0);
    const [answers, setanswers] = useState({});
    const [data, setdata] = useState({});

    const [showanswers, setshowanswers] = useState("");
    const [fontsize, setfontsize] = useState(12);
    const [loading, setloading] = useState(false);
    const [isLoading, setisLoading] = useState(true);
    const [start, setstart] = useState(false);
    const [started_time, setstarted_time] = useState(0);
    const [time_ended, settime_ended] = useState(false);
    const [scoreView, setscoreView] = useState(false);
    const [teacher, setteacher] = useState(userinfo?.userlevel >= 3 ? true: false);

    
    async function loadData() {

        setstarted_time(Date.now());
        let r = await GET(`task/studentLoadTask/?_id=${params?.id}`);
        setdata(r);
        setisLoading(false);

        
    }

    // const { data, error, isLoading } = useQuery(`task-${params?.id}`, loadData); 

    function submit() {

        const conf = window.confirm(t("tasks_send_confirm"));
        if (!conf) {
            return false;
        }

        setloading(true);
        Fetch("task/studentSave", (d) => {

            if (d?.error) {
                setopen({
                    short:t("error",  { returnObjects: true })[d?.error],
                    error:true
                });
            } else {

                setopen({
                    short: t("tasks_student_sent_success"),
                    error:false
                });
                
                setTimeout(() => {
                    if (d?.success?.status == 2) {
                        setscoreView(d?.success?.score);
                    } else {
                        navigate("/myTasks")
                    }
                }, 2700);
                
            }

            setloading(false);
            
        }, { answers: answers, taskID: params?.id, started: started_time });
    }

    function next(type) {
        
        if (!type) {
            setshow(p => data?.task?.questions?.length - 1 > p ? p + 1 : data?.task?.questions?.length - 1);
        } else {
            setshow(p => p > 0 ? p - 1 : 0);
        }
    }

    function showAnswers() {
        setshowanswers(p => !p);
    }

    function fontSizeCg(st) {

        if (st) {
            setfontsize(p => p <= 12 ? 12 :  p - 2);
        } else {
            setfontsize(p => p >= 18 ? 18 :  p + 2);
        }
        
    }

    
    function saveAnswers(d, k) {

        // console.log(d, k);
        
        setanswers(p => ({
            ...p,
            [k]:d
        }));

    }

    function StartTask(d) {
        if (d == "cancel") {
            navigate(-1);
        } else {
            setstart(true);
        }
        
    }

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
                         
        if (!refC?.current) {
            refC.current = true;

            setTimeout(() => {
                
                document.querySelectorAll('.fractionBox').forEach(entry => {
                    
                    entry.addEventListener("keyup", function(inp) {
                        
                        let idElm = entry?.querySelector(".fractionInputVal");
                        let id = idElm?.getAttribute('data-id');
                        
                        let arr = [];
                        
                        entry.querySelectorAll('.fractionInputVal').forEach(e => {
                            
                            let answer = e?.getAttribute('data-answer');
                            let type = e?.getAttribute('data-type');
                            let value = e?.value;

                            let ins = {
                                answer:answer, 
                                type:type, 
                                value:value, 
                            };

                            arr.push(ins);
                        });

                        setanswers(p => ({
                            ...p,
                            [id]:arr
                        }));
                        
                    });
                });

            }, 600);
        }

    }, []);
    

    if (isLoading) {
        return <Loader />
    }

    if (!data?.task?._id) {
        return <Permission />
    }
    
    // if ()

    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            settime_ended(true);
            return <></>;
        } else {
   
            return (
                <span>
                    {zeroPad(hours)}:{zeroPad(minutes)}:{zeroPad(seconds)}
                </span>
            );
        }
    };


    return (
        <>

            <div className='taskBody' >
                {!teacher &&
                <>
                    {scoreView !== false ? <ScoreView score={scoreView} />: false}

                    {!data?.answers?.length ? 
                    <>
                        {time_ended && <TimeEnded />}

                        {!start ? 
                            <Ready onChange={(d) => StartTask(d)} data={data?.task}/>
                        : 
                            <>
                                {data?.task?.timer?.val ? 
                                <div className='timerBox'>
                                    <Countdown date={Date.now() + (data?.task?.timer?.val * 60 * 1000)} zeroPadTime={0} renderer={renderer} />
                                </div>: false}
                            </>
                        }
                    </>: false}
                </>}

                <Header />

                <div className='rightTaskMenu'>
                    
       
                    {/* <a onClick={() => setactivity(p => !p)}>
                        <IoMegaphoneOutline style={{ color: activity ? "#1acca3" : "" }} />
                        <span>{t("task_start_opt_2")}</span>
                    </a> */}
           

                    {userinfo?.userlevel >= 3 && 
                    <>
                        <Link target='_blank' to={`/task/print/${params?.id}/print`}>
                            <MdOutlineLocalPrintshop />
                            <span>{t("task_start_opt_4")}</span>
                        </Link>

                        <Link target='_blank' to={`/task/print/${params?.id}/pdf`}>
                            <MdOutlineFileDownload />
                            <span>{t("task_start_opt_5")}</span>
                        </Link>
                        <a  onClick={showAnswers}>
                            <MdOutlineFactCheck style={{ color:showanswers ? "#1acca3" : "" }} />
                            <span>{t("task_start_opt_6")}</span>
                        </a>
                    </>
                    }
                    

                    <a onClick={() => fontSizeCg()} >
                        <MdOutlineTextIncrease />
                        <span>{t("task_start_opt_7")}</span>
                    </a>
                    <a onClick={() => fontSizeCg(true)}>
                        <MdOutlineTextDecrease />
                        <span>{t("task_start_opt_8")}</span>
                    </a>

                    
                </div>
                
                <Paging number={data?.task?.questions?.length} show={show} setshow={setshow} />
                <div className={`mainWidth taskMainBox f-${fontsize}`}>
                    <div className={`taskBox right`}>

                        <div className='quizMainBox'>
                            {data?.task?.questions?.map((v, k) => {
               
                                return (
                                    // <Question k={k} response={(d) => saveAnswers(d, v?.id)} key={k} data={v} show={show == k || show + 1 == k ? true : false}/>
                                    <Question st_answers={data?.answers?.length ? data?.answers[k] : false} k={k} response={(d) => saveAnswers(d, v?.id)} key={k} data={v} show={show == k ? true : false} showAnswers={showanswers || ""}/>
                                );
                            })}
                        </div>

                        <div className='taskButtonsBox' >
                            {show != 0 && <button onClick={() => next(true)} className='btn gray'><FaArrowRight /></button>}
                            {show + 1 >= data?.task?.questions?.length ?
                                <>
                                    {data?.answers?.length || teacher ? <div style={{flex:1}}></div> : <button onClick={submit} className='btn green next'>{t("task_start_send2")}</button>}
                                </>
                            :
                                <button onClick={() => next()} className='btn next'>{t("next")}</button>
                            }
                            
                        </div>
                        
                    </div>

                    <div className='taskBox left'>

                        <div className='storyBoxText' dangerouslySetInnerHTML={ {__html: data?.task?.story}} />
                       
                    </div>
                </div>
               
            </div>
        </>
    )
}
